import { Component, OnInit } from '@angular/core';
import { MatBottomSheet } from '@angular/material/bottom-sheet';



@Component({
  selector: 'ebb-portal-app-foot',
  templateUrl: './app-foot.component.html',
  styles: []
})
export class AppFootComponent implements OnInit {

  href :string ="/resources/faqs";
  constructor(
    private infoSheet: MatBottomSheet
  ) { }

  ngOnInit() {
    
    if(window.location.hostname.includes('earthquakeauthority.com'))  {
      this.href ="/Homeowner-Resources/FAQ"
    }
  }

}
